import { render, staticRenderFns } from "./pcSubmitOrder.vue?vue&type=template&id=1413d4e4&scoped=true"
import script from "./pcSubmitOrder.vue?vue&type=script&lang=js"
export * from "./pcSubmitOrder.vue?vue&type=script&lang=js"
import style0 from "./pcSubmitOrder.vue?vue&type=style&index=0&id=1413d4e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1413d4e4",
  null
  
)

export default component.exports